
<!--  <div id="email-sent" class="alert alert-primary" role="alert">-->
<!--    Message sent!-->
<!--  </div>-->

<!--<div autocomplete="off" class="login-form">-->
<!--  &lt;!&ndash;  <img src="assets/images/xcde.png" alt="FXCLR" class="img-center mr-5 pt-4" width="120">&ndash;&gt;-->
<!--  <h3 translate>labelHeaderRegister</h3>-->
<!--  <form [formGroup]="registrationForm">-->

<!--    <fieldset class="form-group">-->
<!--      <input type="text" class="form-control" name="username" id="username" placeholder="Enter your username" formControlName="username">-->
<!--    </fieldset>-->

<!--    <fieldset class="form-group">-->
<!--      <input type="email" class="form-control" name="email" id="email" placeholder="Enter email" formControlName="email">-->
<!--    </fieldset>-->

<!--    <fieldset class="form-group">-->
<!--      <input type="password" class="form-control" name="email" id="password" placeholder="Enter password" formControlName="password">-->
<!--    </fieldset>-->

<!--    <fieldset class="form-group">-->
<!--      <input type="password" class="form-control" name="passwordAgain" id="passwordAgain" placeholder="Enter password again" formControlName="passwordAgain">-->
<!--    </fieldset>-->

<!--    <div class="form-group text-center">-->
<!--      <button [disabled]="registrationForm.invalid" (click)="register()" type="submit" class="btn btn-info" name="loginButton" translate><i class="fa fa-lg fa-user-plus"></i> buttonSubmit</button>-->
<!--    </div>-->

<!--  </form>-->

<!--  &lt;!&ndash;      <p><a [routerLink]="'/register'" class="text-white">Create an account</a></p>&ndash;&gt;-->

<!--</div>-->





<!--<div class="modal-header pt-0 pb-0">-->
<!--  <h4 class="modal-title">Register</h4>-->
<!--  <button class="btn btn-link fa fa-2x fa-times pe-0" (click)="modalRef.hide()"></button>-->
<!--</div>-->
<!--<div class="modal-body">-->
<!--  <form [formGroup]="registrationForm">-->

<!--    <fieldset class="form-group">-->
<!--      <input type="text" class="form-control" name="username" id="username" placeholder="Enter your username" formControlName="username">-->
<!--    </fieldset>-->

<!--    <fieldset class="form-group">-->
<!--      <input type="email" class="form-control" name="email" id="email" placeholder="Enter email" formControlName="email">-->
<!--    </fieldset>-->

<!--    <fieldset class="form-group">-->
<!--      <input type="password" class="form-control" name="email" id="password" placeholder="Enter password" formControlName="password">-->
<!--    </fieldset>-->

<!--    <fieldset class="form-group">-->
<!--      <input type="password" class="form-control" name="passwordAgain" id="passwordAgain" placeholder="Enter password again" formControlName="passwordAgain">-->
<!--    </fieldset>-->

<!--    <div class="form-group text-center">-->
<!--      <button [disabled]="registrationForm.invalid" (click)="register()" type="submit" class="btn btn-info" name="loginButton" translate><i class="fa fa-lg fa-user-plus"></i> buttonSubmit</button>-->
<!--    </div>-->

<!--  </form>-->
<!--</div>-->

<!--<div class="modal-footer pt-3">-->
<!--  <button type="button" class="btn btn-outline-primary" (click)="modalRef.hide()">Cancel</button>-->
<!--  <button type="submit" class="btn btn-primary" (click)="register()">Register</button>-->
<!--</div>-->


<!--  <div id="email-sent" class="alert alert-primary" role="alert">-->
<!--    Message sent!-->
<!--  </div>-->

<div>
  <form [formGroup]="registrationForm">

    <fieldset class="form-group">
      <input type="text" class="form-control" name="username" id="username" placeholder="Enter your username" formControlName="username">
    </fieldset>

    <fieldset class="form-group">
      <input type="email" class="form-control" name="email" id="email" placeholder="Enter email" formControlName="email">
    </fieldset>

    <fieldset class="form-group">
      <input type="password" class="form-control" name="email" id="password" placeholder="Enter password" formControlName="password">
    </fieldset>

    <fieldset class="form-group">
      <input type="password" class="form-control" name="passwordAgain" id="passwordAgain" placeholder="Enter password again" formControlName="passwordAgain">
    </fieldset>

    <div class="form-group text-center">
      <button [disabled]="registrationForm.invalid" (click)="register()" type="submit" class="btn btn-info" name="loginButton" translate><i class="fa fa-lg fa-user-plus"></i> buttonSubmit</button>
    </div>

  </form>

</div>

<!--<div class="loading">-->
<!--  Loading...-->
<!--</div>-->


